<template>
    <div class="container mt-3 container_products product_details">
           <!-- عدد المنتجات -->
           <div class="d-flex justify-content-between align-items-center mb-3">
               <span>({{ count }}) {{ $t('products') }}</span>
   
               <!-- أيقونات عرض الشبكة والقائمة -->
               <div>
   
                   <button class="btn btn-outline-secondary btn-sm" id="btn_grid" @click="showGrid()">
                       <i class="bi bi-grid"></i>
                   </button>
   
                   <button class="btn btn-outline-secondary btn-sm" id="btn_list" @click="showList()">
                       <i class="bi bi-list"></i>
                   </button>
   
                   <!-- القائمة المنسدلة -->
                   <div class="div_sort">
                       <span>
                           {{ $t('Sort by') }} :
                       </span>
                       <div class="dropdown-container" style="display: inline">
   
   
                           <select @change="upadatesort($event)" id="country-select_sort">
                               <option value="desc/id">{{ $t("default sorting") }}</option>
                               <option value="desc/id">{{ $t("Newest Arrivals") }}</option>
                               <option value="asc/id">{{ $t("Oldest Arrivals") }}</option>
                               <option value="desc/sale_price">{{ $t("Price - Low to High") }}</option>
                               <option value="asc/sale_price">{{ $t("Price - High to Low") }}</option>
                               <option value="desc/count_view">{{ $t("Views - Low to High") }}</option>
                               <option value="asc/count_view">{{ $t("Views - High to Low") }}</option>
                               <option value="desc/quantity">{{ $t("qnt - High to Low") }}</option>
                               <option value="asc/quantity">{{ $t("qnt - Low to High") }}</option>
                               <option value="desc/count_sold">{{ $t("sold - Low to High") }}</option>
                               <option value="asc/count_sold">{{ $t("sold - High to Low") }}</option>
                           </select>
   
   
                       </div>
                   </div>
   
   
               </div>
       
           </div>
           <!-- المسار (Breadcrumb) -->
           <nav aria-label="breadcrumb">
               <ol class="breadcrumb">
                   <li class="breadcrumb-item active" aria-current="page">{{ $t('products') }}</li>
               </ol>
           </nav>
   
           <!-- تصنيفات المنتجات مع التمرير في الموبايل -->
      
   
           <div class=" mt-4">
   
               <div  class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4  " id="grid">
   
                   <!-- المنتج الأول -->
                   <product_grid v-for="(item, index) in this.products" :key="index" :name="item.name"
                       :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                       :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                       :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer"
                       :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount"
                       :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
                       :range_price="item.range_price"  :jellwery="item.jewelry"></product_grid>
   
   
   
               </div>
   
               <!-- list-->
   
               <div  class="container mt-4" id="list" style="display: none;">
                   <product_list v-for="(item, index) in this.products" :key="index" :name="item.name"
                       :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                       :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                       :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer"
                       :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount"
                       :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
                       :range_price="item.range_price"  :jellwery="item.jewelry"></product_list>
               </div>
   
   
   
   
               <!--  -->
           </div>
           <div class="col-lg-12 text-center ">
               <nav aria-label="Page navigation example">
   
                   <b-pagination v-if="this.products.length != 0" v-model="page" :total-rows="count"
                       :per-page="this.paginate" :prev-text="$t('prev')" :next-text="$t('next')" pills size="sm"
                       class="paginate_theme13" @change="handlePageChange"></b-pagination>
               </nav>
           </div><!--end col-->
   
   
       </div>
   </template>
   <script>
   import product_grid from "../components/one_product_list.vue";
   import product_list from "../components/one_product_list _vertical.vue";
   
   import { HalfCircleSpinner, HollowDotsSpinner } from "epic-spinners";
   
   
   export default {
     components: { product_grid,product_list, HollowDotsSpinner, HalfCircleSpinner},
     data() {
       return {
           show_list:false,
           show_grid:true,
           DBitems: null,
         loading: false,
         loading_product: false,
         products:[],
         page: 1,
         count: 0,
         pageSize: 12,
         langChange:"",
         sort:'id',
         order:'desc',
         paginate:12,
         pagefrom:1,
         pageto:12
       };
     },
     created() {
     
   
       this.loading = true;
       this.loading_product = true;
       this.axios
         .post(
           this.$store.state.base_api_url + this.$store.storeName + "/theme5/products",
           
               {
               sort:  this.sort,
               order: this.order,
               paginate: this.paginate
           },
           {
             headers: {
               "Accept-Language": this.$i18n.locale,
               Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
             }
           }
           
         )
         .then((response) => {
           this.products = response.data.data;
           this.count = response.data.meta.total;
           this.pagefrom=response.data.meta.from;
           this.pageto=response.data.meta.to;
           this.loading_product = false
         })
         .then(() => (this.loading = false ));
         if(this.$i18n.locale=='ar')
         {
         document.title = this.$store.state.title_ar;
         document.getElementById("description_meta").content=this.$store.state.description_ar;
         document.getElementById("keywords_meta").content=this.$store.state.keyword_ar;
         }
         else{
           document.title = this.$store.state.title_en;
         document.getElementById("description_meta").content=this.$store.state.description_en;
         document.getElementById("keywords_meta").content=this.$store.state.keyword_en;
         }
     },
     watch: {
       langChange() {
         this.loading = true;
         this.axios
           .post(
             this.$store.state.base_api_url +
               this.$store.storeName +
               "/theme5/products?page=" +
               this.page,
               {
               sort:  this.sort,
               order: this.order,
               paginate: this.paginate
           },
             {
               headers: {
                 "Accept-Language": this.$i18n.locale,
                 Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
               }
             }
           )
           .then((response) => {
             this.products = response.data.data;
             //this.count = response.data.meta.total;
           }).then(() => {
           this.loading = false;
         });
       },
     },
     updated() {
       this.langChange=this.$i18n.locale
     },
     methods: {
       closepopup()
       {
         this.$store.state.show_product=false;
       },
       retrieveTutorials() {
         const params = this.page;
   
         this.loading_product = true;
         this.axios
           .post(
             this.$store.state.base_api_url +
               this.$store.storeName +
               "/theme5/products?page=" +
               params,
             
               {
               sort:  this.sort,
               order: this.order,
               paginate: this.paginate
           },{
               headers: {
                 "Accept-Language": this.$i18n.locale,
                 Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
               }
               }
             
           )
           .then((response) => {
             this.products = response.data.data;
             //this.count = response.data.meta.total;
             this.pagefrom=response.data.meta.from;
             this.pageto=response.data.meta.to;
           })
           .then(() => (this.loading_product = false));
         /*.catch((e) => {
             console.log(params);
             console.log(e);
           });*/
       },
       handlePageChange(value) {
         this.page = value;
         this.retrieveTutorials();
       },
   
       upadatesort(event)
     {
       this.order = event.target.value.split("/")[0]; //asc
         this.sort = event.target.value.split("/")[1]; //id
   
         this.filter_product();
     },
     filter_product()
       {
           console.log('brands array  ',this.brands_array);
   
   
           this.axios
           .post(
             this.$store.state.base_api_url +
               this.$store.storeName +
               "/theme5/products",
               {
               sort:  this.sort,
               order: this.order,
               paginate: this.paginate
           },
             {
               headers: {
                 "Accept-Language": this.$i18n.locale,
                 Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
               }
             }
           )
           .then((response) => {
             this.products = response.data.data;
             //this.count = response.data.meta.total;
           }).then(() => {
           this.loading = false;
         });
       },
   
     updatepaginate(event)
     {
       this.paginate = event.target.value
   
         this.filter_product();
     },
     change_style_product($type)
     {
      // this.element=document.getElementById('product_style');
       if ($type=='grid') {
               $('.shop_container').removeClass('list').addClass('grid');
         $('.grid').addClass('active').siblings().removeClass('active');
           //	this.element.addClass('active').siblings().removeClass('active');
           }
           else if($type=='list') {
               $('.shop_container').removeClass('grid').addClass('list');
               //this.element.addClass('active').siblings().removeClass('active');
         $('.list').addClass('active').siblings().removeClass('active');
   
           }
           $(".shop_container").append('<div class="loading_pr"><div class="mfp-preloader"></div></div>');
           setTimeout(function(){
               $('.loading_pr').remove();
               $container.isotope('layout');
           }, 800);
     },
     showList() {
               document.getElementById('btn_grid').style = "border:1px solid black";
               document.getElementById('btn_list').style = "border:2px solid black";
   
               document.getElementById('list').style = "display:none";
               document.getElementById('grid').style = "display:block";
             
             
           },
           showGrid() {
               document.getElementById('btn_grid').style = "border:2px solid black";
               document.getElementById('btn_list').style = "border:1px solid black";
   
               document.getElementById('grid').style = "display:block";
               document.getElementById('list').style = "display:none";
              
           },
     },
   };
   </script>